import { useCallback } from 'react'

import { trackEvent } from '~/shared/lib/analytics'

import { DOCUMENT_REVIEW_COMPLETED, DOCUMENT_STEP_COMPLETED } from '../config'
import { clearStepStartTime, getStepStartTime, setLastCompletionTime } from '../lib/storage'

import { useStepSession } from './step-session-context'

export function useStepCompletion() {
  const { step, documentKey, hasDownloaded, getIdleTime } = useStepSession()

  const trackStepCompletion = useCallback(
    (outcome?: 'matched' | 'no_match') => {
      const startTime = getStepStartTime(documentKey, step)
      if (startTime === null) return

      const elapsedSec = (Date.now() - startTime) / 1000
      const idleSec = getIdleTime()
      const stepDurationSec = Math.max(0, elapsedSec - idleSec)

      trackEvent(DOCUMENT_STEP_COMPLETED, {
        step,
        document_key: documentKey,
        step_duration_sec: Math.round(stepDurationSec * 100) / 100,
      })

      clearStepStartTime(documentKey, step)

      if (step === 'patient_matching') {
        trackEvent(DOCUMENT_REVIEW_COMPLETED, {
          document_key: documentKey,
          outcome: outcome ?? 'no_match',
          has_downloaded: hasDownloaded,
        })
        setLastCompletionTime()
      }
    },
    [step, documentKey, hasDownloaded, getIdleTime],
  )

  return { trackStepCompletion }
}
